var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8536 7.14645L17.8536 10.1464C18.0488 10.3417 18.0488 10.6583 17.8536 10.8536L14.8536 13.8536C14.6583 14.0488 14.3417 14.0488 14.1464 13.8536C13.9512 13.6583 13.9512 13.3417 14.1464 13.1464L16.292 11H0.5C0.223858 11 2.01044e-09 10.7761 2.01044e-09 10.5C2.01044e-09 10.2239 0.223858 10 0.5 10H16.292L14.1464 7.85355C13.9512 7.65829 13.9512 7.34171 14.1464 7.14645C14.3417 6.95118 14.6583 6.95118 14.8536 7.14645ZM0.146447 3.14645L3.14645 0.146447C3.34171 -0.0488155 3.65829 -0.0488155 3.85355 0.146447C4.02712 0.320013 4.0464 0.589437 3.91141 0.784306L3.85355 0.853553L1.707 3H17.5C17.7455 3 17.9496 3.17688 17.9919 3.41012L18 3.5C18 3.74546 17.8231 3.94961 17.5899 3.99194L17.5 4H1.707L3.85355 6.14645C4.02712 6.32001 4.0464 6.58944 3.91141 6.78431L3.85355 6.85355C3.67999 7.02712 3.41056 7.0464 3.21569 6.91141L3.14645 6.85355L0.146447 3.85355C-0.0271197 3.67999 -0.0464049 3.41056 0.0885912 3.21569L0.146447 3.14645Z",
    fill: "#007CB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.01a3bcba9b492e3be985586c3f37fd61.svg";
export { ForwardRef as ReactComponent };